import * as S from './styles'

interface IEditButtonProps {
  onClick?: () => void
}

const EditButton = ({ onClick }: IEditButtonProps) => {
  return (
    <S.ContainerEdit onClick={onClick}>
      <span>Editar</span>
      <S.Edit />
    </S.ContainerEdit>
  )
}

export { EditButton }
export type { IEditButtonProps }
